import { render, staticRenderFns } from "./Datacollection.vue?vue&type=template&id=b07fe924&scoped=true"
import script from "./Datacollection.vue?vue&type=script&lang=js"
export * from "./Datacollection.vue?vue&type=script&lang=js"
import style0 from "./Datacollection.vue?vue&type=style&index=0&id=b07fe924&prod&scoped=true&lang=css"
import style1 from "./Datacollection.vue?vue&type=style&index=1&id=b07fe924&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07fe924",
  null
  
)

export default component.exports